<template>
  <!-- 行政区域信息 -->
  <a-cascader
    v-model="treeValues"
    filterable
    :show-all-levels="false"
    :options="areaSource"
    @change="treeChange"
    placeholder="请选择所在城市"
    :field-names="{
      label: 'name',
      value: 'code',
      children: 'areaList',
    }"
  />
</template>
<script>
import axios from "axios"
export default {
  name: "行政区域规划",
  props: {
    treeNodeVal: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      areaSource: [],
      treeValue: undefined,
      treeValues: [],
      isselect: false,
    };
  },
  watch: {
    treeNodeVal(newV) {
      if (newV) {
        this.getCodesByCode(newV);
      }
    }
  },
  mounted() {
    this.getArea().then(() => {
      let treeNodeVal = this.treeNodeVal;
      if (treeNodeVal) {
        this.getCodesByCode(treeNodeVal);
      }
    });
  },
  methods: {
    getCodesByCode(val) {
      if (!val) {
        return;
      }
      this.getSelectedItem(val, this.areaSource);
    },
    getAreaName(val) {
      let url = `/api/v1/city/nameByCode/${val}`;
      axios.get(url, {}).then((res) => {
        if (res.code == 0 || res.code == 200) {
          this.treeValue = {
            label: res.data,
            value: val,
          };
        } else {
          this.treeValue = undefined;
        }
      });
    },
    //获取区域信息
    getArea() {
      return new Promise((resolve, reason) => {
        // let area = this.$store.state.areaList;
        // if (area.length > 0) {
        //   this.areaSource = area;
        //   return;
        // }
        let url = `../../administrativeArea.json`;
        // let url = `/api/v1/city/all`;
        axios.get(url, {}, false, true).then((res) => {
          this.areaSource = res.data;
          resolve(res);
        });
      });
    },
    //地区树选择事件
    treeChange(nodeValue, node) {
      let value = undefined;
      if (nodeValue.length > 0) {
        value = nodeValue[nodeValue.length - 1];
      }
      this.$emit("callBackTreeValue", value);
    },
    //当前选中对象的title(拼接所有父级name)
    getSelectedItem(value, data) {
      for (let item of data) {
        if (this.isselect) {
          return;
        }
        this.treeValues = [];
        this.treeValues.push(item.code);
        //根节点未找到继续递归查找
        if (item.areaList) {
          this.getSelectedChild(value, item.areaList);
        }
      }
    },
    getSelectedChild(value, data, code) {
      for (let item of data) {
        //在根节点找到对应选项
        if (item.code == value) {
          this.treeValues.push(code);
          this.treeValues.push(item.code);
          this.isselect = true;
        } else if (item.areaList) {
          this.getSelectedChild(value, item.areaList, item.code);
        }
      }
    },
  },
};
</script>